import {
    array,
    boolean as booleanType,
    coerce,
    enums,
    number,
    optional,
    string,
    validate,
} from "superstruct"

const ARRAY_SEPARATOR = "|"

export function parseArrayOfNumbers(from: number, to: number) {
    return coerce(array(number()), optional(string()), (value) => {
        if (!value) return []
        const result: number[] = []
        const NumberStruct = parseNumber(from, to)

        for (const str of value.split(ARRAY_SEPARATOR)) {
            const [err, num] = validate(str, NumberStruct, { coerce: true })
            if (!err) {
                result.push(num)
            }
        }

        return result
    })
}

export function parseString(defaultValue: string) {
    return coerce(string(), optional(string()), (value = defaultValue) => {
        if (!value) return defaultValue
        return value
    })
}

export function parseEnums<T extends string>(values: readonly T[], defaultValue: T) {
    return coerce(enums(values), optional(string()), (value) => {
        if (value?.length == 0) return defaultValue
        if (!values.includes(value as T)) return defaultValue
        return value as T
    })
}

export function parseNumber(from: number, to: number, defaultValue?: number) {
    return coerce(number(), optional(string()), (value) => {
        if (!value) return defaultValue

        const num = parseFloat(value)

        if (
            Number.isNaN(num) ||
            !Number.isFinite(num) ||
            !Number.isInteger(num) ||
            num < from ||
            num > Number.MAX_SAFE_INTEGER ||
            num > to
        ) {
            return defaultValue
        }
        return num
    })
}

export function parseBool() {
    return coerce(booleanType(), optional(string()), (value = "") => {
        if (value.length == 0) return false
        return value === "true" || value === "1"
    })
}
